import { useEffect } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';

import { dragTypes } from '../dnd/dragTypes';

import { useEventCallback } from '../../hooks/useEventCallback';

export function useMoodDragDrop({ moodId, isDisabled, onDrop, onDragEnd, onRequestSwap, render }) {
  const renderFunction = useEventCallback((...args) => {
    return render(...args);
  });

  const [{ isDragging }, dragRef, preview] = useDrag(() => {
    return {
      type: dragTypes.MOOD,
      item: () => {
        return {
          type: dragTypes.MOOD,
          id: moodId,
          render: renderFunction,
        };
      },
      canDrag(monitor) {
        return isDisabled !== true;
      },
      end(dragItem, dragMonitor) {
        onDragEnd?.({ didDrop: dragMonitor.didDrop() });
      },
      collect(dragMonitor) {
        return {
          isDragging: dragMonitor.isDragging(),
        };
      },
    };
  }, [moodId, isDisabled]);

  const [, dropRef] = useDrop(() => {
    return {
      accept: [dragTypes.MOOD],
      canDrop(item, monitor) {
        return isDisabled !== true;
      },
      hover(item) {
        if (item.id !== moodId) {
          onRequestSwap?.({ firstId: moodId, secondId: item.id });
        }
      },
      drop(item, monitor) {
        onDrop?.(item);
      },
    };
  }, [moodId, isDisabled, onRequestSwap, onDrop]);

  useEffect(() => {
    preview(getEmptyImage());
  }, [preview]);

  return {
    dragRef,
    dropRef,
    isDragging,
  };
}
